// Cliente de tracking de eventos para el funnel de Zenviq.
// El backend (POST /api/track) acepta un Bearer token opcional para asociar usuario.

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
const SESSION_KEY = "zenviq_session";

function generateUuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  // Fallback simple para entornos sin crypto.randomUUID
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
      id = generateUuid();
      localStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

export async function track(tipo, metadata = null) {
  try {
    const token = localStorage.getItem("token");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;

    const ruta = typeof window !== "undefined"
      ? window.location.pathname + window.location.hash
      : null;

    await fetch(`${API_URL}/api/track`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        tipo,
        session_id: getSessionId(),
        ruta,
        metadata: metadata || undefined,
      }),
      keepalive: true,
    });
  } catch {
    // tracking nunca debe romper el flujo principal
  }
}
